const gwasviz_single_trait_conf = {
    'species': 'Pop332',
    'query_trait': 'SlFM0513',
    'query_chr': '2',
    'query_loc_start': 34500000,
    'query_loc_end': 35000000,
    'region': '2:34500000-35000000'
}

export default gwasviz_single_trait_conf
